//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import zdialog from "@/components/toast/Zdialog.vue";
export default {
    data(){
        return {
            title:'效果损伤详细',
            message:[
                {
                    title:'面部',
                    cont:[
                        {
                            head:'定义：',
                            cont:'面部的范围是指前额发际下，两耳屏前与下颌下缘之间的区域，包括额部、眶部、鼻部、口唇部、颏部、颧部、颊部、腮腺咬肌部。（不含鼻腔及口腔内部）',
                        },
                        {
                            head:'医美损害责任范围：',
                            cont:'<p>·肉眼可见的皮下硬结</p><p>·手术刀口以外部位，面部线条状瘢痕</p><p>·手术刀口以外部位，面部块状瘢痕</p><p>·皮肤坏死</p><p>·医学美容治疗所指的细小瘢痕及色素沉着</p><p>·手术刀口，形成面部瘢痕</p><p>·烧伤深度达到2度</p><p>·双侧眉毛下缘任一对称点，至同侧上睑缘距离相差≥0.5cm</p><p>·重睑皱襞宽窄不对称</p><p>·内眦，两眼眼角角度相差≥15 度</p><p>·外眦，两眼眼长相差≥0.5cm</p><p>·鼻孔，两侧鼻孔截面积相差 15%</p><p>·颧骨手术后出现面部不对称，影像检查显示双侧颧骨高点不在同一水平线</p><p>·酒窝（含梨涡），站姿，静态表情下双侧酒窝（或梨涡）中心点与面部中线垂直距相差≥1cm</p><p>·唇峰，站姿，双侧唇峰不在同一水平线上</p><p>·下颌骨手术后出现颏颌角不对成</p><p>·隆鼻术后出现鼻部歪斜</p><p>·假体脱出（包含假体导致的皮肤穿孔）</p><p>·假体错位、移位</p><p>·眼角膜溃疡</p><p>·重睑术后单侧眼睑褶皱层数＞2</p><p>·任一侧上睑轻度下垂</p><p>·眶下睑沟及眼鼻沟凹陷畸形</p><p>·短鼻畸形</p><p>·假体边界显现</p><p>·实施鼻部项目后，出现鼻头挛缩</p><p>·单侧上唇下缘出现弧度缺陷，或呈“吹口哨状唇畸形”</p><p>·面部填充术后，填充区域皮肤表面呈现肉眼可见的凹凸不平</p><p>·面部实施吸脂术90日后，吸脂区域皮肤表面呈现肉眼可见的凹凸不平</p><p>·任一侧睑裂闭合不全</p><p>·手术区域埋线线头露出</p><p>·下颌骨手术后，出现下颌骨凹陷</p><p>·隆鼻术后出现鼻背部凹陷或驼峰鼻</p>',
                        },
                    ],
                    
                },
                {
                    title:'颈部',
                    cont:[
                        {
                            head:'定义：',
                            cont:'颈部的上界为下颌骨下缘、下颌支后缘、乳突和枕外隆突的连线，下界即胸骨上缘、锁骨、肩峰和第七颈椎棘突间的连线',
                        },
                        {
                            head:'医美损害责任范围：',
                            cont:'<p>·烧伤深度达到2度</p><p>·手术刀口以外部位，块状瘢痕</p><p>·手术刀口以外部位，线条状瘢痕</p><p>·手术刀口，形成瘢痕</p>',
                        },
                    ],
                },
                {
                    title:'胸部',
                    cont:[
                        {
                            head:'定义：',
                            cont:'上界为颈部下界，下界为骨性胸廓下口，外界为三角肌前后缘',
                        },
                        {
                            head:'医美损害责任范围：',
                            cont:'<p>·隆胸术后出现钙化的脂肪结节、钙化的硬结</p><p>·烧伤深度达到2度</p><p>·手术刀口以外部位，块状瘢痕</p><p>·手术刀口以外部位，线条状瘢痕</p><p>·手术刀口，形成瘢痕</p><p>·乳房，正面站姿，双侧乳头至乳房边缘对称点的距离相差≥1.5cm,或双侧乳房最高点不在同一水平线，垂直相差≥1.5cm</p><p>·乳晕，站姿，直径相差≥1cm</p><p>·包膜挛缩严重，需取出假体</p><p>·假体错位、移位</p><p>·假体脱出</p>',
                        },
                    ],
                },
                {
                    title:'腰腹',
                    cont:[
                        {
                            head:'定义：',
                            cont:'骨盆和胸部之间的身体部分',
                        },
                        {
                            head:'医美损害责任范围：',
                            cont:'<p>·吸脂区域皮肤表面呈现肉眼可见的凹凸不平</p><p>·手术刀口以外部位，块状瘢痕	</p><p>·手术刀口以外部位，线条状瘢痕</p><p>·手术刀口，形成瘢痕</p><p>·烧伤深度达到2度</p>',
                        },
                    ],
                },
                {
                    title:'臀部',
                    cont:[
                        {
                            head:'定义：',
                            cont:'是腰与腿的结合部',
                        },
                        {
                            head:'医美损害责任范围：',
                            cont:'<p>·吸脂区域皮肤表面呈现肉眼可见的凹凸不平</p><p>·隆臀术后形成皮下硬结</p><p>·假体植入导致股瓣不对称</p><p>·烧伤深度达到2级</p><p>·手术刀口以外部位，线条状瘢痕</p><p>·手术刀口以外部位，块状瘢痕</p>',
                        },
                    ],
                },
                {
                    title:'胳膊及腿、背部',
                    cont:[
                        {
                            head:'定义：',
                            cont:'剩余部位',
                        },
                        {
                            head:'医美损害责任范围：',
                            cont:'<p>·吸脂区域皮肤表面仍呈现肉眼可见的凹凸不平</p><p>·手术刀口以外部位，线条状瘢痕</p><p>·手术刀口以外部位，块状瘢痕</p><p>·手术刀口，形成瘢痕</p>',
                        },
                    ],
                },
                {
                    title:'手',
                    cont:[
                        {
                            head:'医美损害责任范围：',
                            cont:'<p>·肉眼可见的皮下硬结</p><p>·手术刀口以外部位，线条状瘢痕</p><p>·手术刀口以外部位，块状瘢痕</p><p>·手术刀口，形成瘢痕</p>',
                        },
                    ],
                },
            ],
    
          }
    },
    components:{
        zdialog,
    },
    created(){
    },
    mounted () {
        this.$refs.zdialog.showoast();
    },
}
